import type React from 'react'
import type { JSX } from 'react'
import type { IInlineArrowDownWithTitleProps } from 'atoms/Button/Templates'
import type { ITextBlockDescriptionForSpecialRowProps } from 'blocks/TextBlock/Templates'
import type { IContainerDescriptionProps } from '../ContainerDescription'

import { InlineArrowDownWithTitle } from 'atoms/Button/Templates'
import { WrapperSpecialTitle } from 'blocks/Container/Description'
import { TextBlockDescriptionForSpecialRowCenter } from 'blocks/TextBlock/Templates'
import { FIXED_INDENTS } from 'vars/index'
import { ContainerDescription } from '../ContainerDescription'
import {
  ContainerDescriptionAlignItems,
  ContainerDescriptionJustifyContent,
  ContainerDescriptionRowGap,
} from '../ContainerDescription.h'

export interface IContainerDescriptionForSpecialRowWithAngleCenterProps extends Omit<
  IContainerDescriptionProps,
  'children'
> {
  children?: React.ReactNode
  title?: ITextBlockDescriptionForSpecialRowProps['title']
  description?: ITextBlockDescriptionForSpecialRowProps['description']
  buttonTitle?: IInlineArrowDownWithTitleProps['title']
  isButtonShown?: boolean
  onSeeAllClick?: () => void
}

export const ContainerDescriptionForSpecialRowWithAngleButtonCenter = ({
  title = '',
  description = '',
  buttonTitle = '',
  isButtonShown = false,
  alignItems = ContainerDescriptionAlignItems.Center,
  rowGap = ContainerDescriptionRowGap.INDENT_40,
  justifyContent = ContainerDescriptionJustifyContent.Center,
  children,
  paddings = [
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  onSeeAllClick,
  ...rest
}: IContainerDescriptionForSpecialRowWithAngleCenterProps): JSX.Element => {
  const isButton = !children && isButtonShown && buttonTitle

  return (
    <WrapperSpecialTitle
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      <ContainerDescription
        alignItems={alignItems}
        justifyContent={justifyContent}
        rowGap={rowGap}
        paddings={paddings}
        {...rest}
      >
        <TextBlockDescriptionForSpecialRowCenter
          title={title}
          description={description}
          width={100}
        />
        {children}
        {isButton && (
          <InlineArrowDownWithTitle
            onClick={onSeeAllClick}
            title={buttonTitle}
          />
        )}
      </ContainerDescription>
    </WrapperSpecialTitle>
  )
}

ContainerDescriptionForSpecialRowWithAngleButtonCenter.displayName =
  'ContainerDescriptionForSpecialRowWithAngleButtonCenter'
